<template>
  <div id="app" class="el-scrollbar__wrap" @scroll="scrollEvent"
    :style="(($route.meta.navbar||$route.meta.navbar==0)&&$route.meta.navbar!=4)&&onoff&&canSubmint?'padding-bottom:268px;':''">
    <navbar v-if="$route.meta.navbar||$route.meta.navbar==0" :tabState="$route.meta.navbar"
      @itemClick="itemClick">
    </navbar>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <div class="kefuBox" v-if="$route.meta.navbar||$route.meta.navbar==0">
      <el-tooltip class="item" effect="dark" content="咨询电话：0755-86705865" placement="left-start">
        <img style="margin-bottom:14px;" src="./assets/kefu1.png" alt />
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="投诉建议" placement="left-start">
        <img style="cursor: pointer;margin-bottom:14px;" @click="toushu" src="./assets/kefu2.png"
          alt="投诉建议" />
      </el-tooltip>
      <el-popover placement="left" title width="150" trigger="hover" content>
        <img width="125px" src="./assets/gongzhonghao.jpg" alt />
        <div style="text-align:center;">微信扫一扫</div>
        <div style="text-align:center;">关注上户公众号</div>
        <img slot="reference" src="./assets/kefu3.png" alt="关注公众号" />
      </el-popover>

      <!-- <el-tooltip class="item" effect="dark" content="电话：0755-86705865" placement="left-start">
        <img src="./assets/kefu.png" style="margin-top:14px;" alt class="kefu" />
      </el-tooltip>-->
    </div>
    <!-- 返回头部 -->
    <el-backtop style="border-radius:4px;box-shadow: none;" target=".el-scrollbar__wrap"
      :bottom="100" v-if="$route.meta.navbar||$route.meta.navbar==0">
      <img src="./assets/backTop.png" alt class="backTop" />
    </el-backtop>

    <!-- 信息提交窗口 -->
    <transition name="el-fade-in-linear">
      <div class="submitBox"
        v-show="(($route.meta.navbar||$route.meta.navbar==0)&&$route.meta.navbar!=4)&&onoff&&canSubmint">
        <img src="./assets/auntLogo.png" alt class="auntLogo" />
        <div class="middle">
          <p class="title1">为找阿姨而烦恼？阿姨如何管理？怎么快速找到阿姨？</p>
          <p class="title2">赶紧下载上户APP，25W+阿姨在线找工作</p>
          <div class="inputBox flex-h flex-hc">
            <el-input type="text" clearable placeholder="您的称呼" v-model="userName" class="input1"
              maxlength="20"></el-input>
            <el-input type="text" clearable placeholder="公司名称" v-model="companyName" class="input2"
              maxlength="50"></el-input>
            <el-input type="text" clearable placeholder="手机号" v-model="userPhone" class="input3">
            </el-input>
            <el-button type="primary" class="submitBtn" @click="submitEvent">提交</el-button>
          </div>
        </div>
        <div class="closeBox flex-v flex-hc flex-vc" @click="closeEvent">
          <img src="./assets/close.png" alt />
        </div>
      </div>
    </transition>
    <foot v-if="$route.meta.foot"></foot>
  </div>
</template>
<script>
import navbar from "@/components/navbar";
import foot from "@/components/foot";
import { mapState, mapMutations } from "vuex";
import { async } from "@/config/fetch";


export default {
  name: "App",
  components: {
    navbar,
    foot,
  },
  data () {
    return {
      userName: "",
      companyName: "",
      userPhone: "",
      onoff: false,
      canSubmint: true, //是否可以提交
    };
  },
  created () {
    console.log("APP.vue >>> created");
  },
  mounted () {
    console.log(navigator.userAgent);
    if (this.getCookie('U_id')) {
      async(
        "/loginController/addUserEquipmentInfo.do",
        {
          companyUserId: encodeURIComponent(this.getCookie('U_id')),
          ieUa: 1
        },
        "POST"
      )
        .then((data) => {
          console.log(data);

        })
        .catch((err) => {

        });
    }
  },
  methods: {
    itemClick (obj) {
      this.$router.push(obj.goRoute);
    },
    getCookie (name) {
      var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if (arr = document.cookie.match(reg))
        // return (arr[2]);
        return unescape(arr[2]);
      else
        return null;
    },
    toushu () {
      this.$router.push("/advice");
    },
    scrollEvent (e) {
      if (e.target.scrollTop > window.innerHeight / 2) {
        this.onoff = true;
      } else {
        this.onoff = false;
      }
    },
    // 关闭弹窗
    closeEvent () {
      this.canSubmint = false;
    },
    // 提交
    submitEvent () {
      var _this = this;
      _this.userName = _this.userName.replace(/(^\s*)|(\s*$)/g, "");
      if (_this.userName == "") {
        _this.$message({
          message: "请填写您的称呼",
          type: "warning",
        });
        return;
      }
      _this.companyName = _this.companyName.replace(/(^\s*)|(\s*$)/g, "");

      if (_this.companyName == "") {
        _this.$message({
          message: "请填写公司名称",
          type: "warning",
        });
        return;
      }
      _this.userPhone = _this.userPhone.replace(/(^\s*)|(\s*$)/g, "");

      if (_this.userPhone == "") {
        _this.$message({
          message: "请填写手机号",
          type: "warning",
        });
        return;
      }
      async(
        "/userFeedbackController/addInfo.do",
        {
          type: 1,
          userName: encodeURIComponent(_this.userName),
          companyUserName: encodeURIComponent(_this.companyName),
          userPhone: _this.userPhone,
        },
        "POST"
      )
        .then((data) => {
          console.log(data);
          if (data.reCode == 100) {
            if (data.data.dateCode == 200) {
              _this.$message({
                message: "提交成功",
                type: "success",
              });
              _this.canSubmint = false;
            } else {
              _this.$message.error({
                message: data.data.dateMsg,
              });
            }
          } else {
            _this.$message({
              message: data.reMsg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          _this.$message.error({
            message: "加载失败！",
          });
        });
    },
  },
};
</script>

<style>
.swiper-pagination-bullet-active {
  background: #00a14d !important;
}

html,
body {
  height: 100%;
}
#app {
  height: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2a2a2a;
}
/* 子元素-平均分栏 */
.flex1 {
  -webkit-box-flex: 1; /* OLD - iOS 6-, Safari 3.1-6 */
  -moz-box-flex: 1; /* OLD - Firefox 19- */
  width: 20%; /* For old syntax, otherwise collapses. */
  -webkit-flex: 1; /* Chrome */
  -ms-flex: 1; /* IE 10 */
  flex: 1; /* NEW, Spec - Opera 12.1, Firefox 20+ */
}
/* 父元素-横向排列（主轴） */
.flex-h {
  display: box; /* OLD - Android 4.4- */

  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
  display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
  display: -ms-flexbox; /* TWEENER - IE 10 */
  display: -webkit-flex; /* NEW - Chrome */
  display: flex; /* NEW, Spec - Opera 12.1, Firefox 20+ */

  /* 09版 */
  -webkit-box-orient: horizontal;
  /* 12版 */
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;
}
/* 父元素-横向换行 */
.flex-hw {
  /* 09版 */
  /*-webkit-box-lines: multiple;*/
  /* 12版 */
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
}
/* 父元素-水平居中（主轴是横向才生效） */
.flex-hc {
  /* 09版 */
  -webkit-box-pack: center;
  /* 12版 */
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  justify-content: center;
  /* 其它取值如下：
        align-items     主轴原点方向对齐
        flex-end        主轴延伸方向对齐
        space-between   等间距排列，首尾不留白
        space-around    等间距排列，首尾留白
     */
}
/* 父元素- 等间距排列，首尾留白 */
.flex-space-around {
  /* 09版 */
  -webkit-box-pack: space-between;
  /* 12版 */
  -webkit-justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  -o-justify-content: space-between;
  justify-content: space-between;
  /* 其它取值如下：
        align-items     主轴原点方向对齐
        flex-end        主轴延伸方向对齐
        space-between   等间距排列，首尾不留白
        space-around    等间距排列，首尾留白
     */
}

/* 父元素-纵向排列（主轴） */
.flex-v {
  display: box; /* OLD - Android 4.4- */

  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
  display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
  display: -ms-flexbox; /* TWEENER - IE 10 */
  display: -webkit-flex; /* NEW - Chrome */
  display: flex; /* NEW, Spec - Opera 12.1, Firefox 20+ */

  /* 09版 */
  -webkit-box-orient: vertical;
  /* 12版 */
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
}
/* 父元素-纵向换行 */
.flex-vw {
  /* 09版 */
  /*-webkit-box-lines: multiple;*/
  /* 12版 */
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
}
/* 父元素-竖直居中（主轴是横向才生效） */
.flex-vc {
  /* 09版 */
  -webkit-box-align: center;
  /* 12版 */
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
}
/* 子元素-显示在从左向右（从上向下）第1个位置，用于改变源文档顺序显示 */
.flex-1 {
  -webkit-box-ordinal-group: 1; /* OLD - iOS 6-, Safari 3.1-6 */
  -moz-box-ordinal-group: 1; /* OLD - Firefox 19- */
  -ms-flex-order: 1; /* TWEENER - IE 10 */
  -webkit-order: 1; /* NEW - Chrome */
  order: 1; /* NEW, Spec - Opera 12.1, Firefox 20+ */
}
/* 子元素-显示在从左向右（从上向下）第2个位置，用于改变源文档顺序显示 */
.flex-2 {
  -webkit-box-ordinal-group: 2; /* OLD - iOS 6-, Safari 3.1-6 */
  -moz-box-ordinal-group: 2; /* OLD - Firefox 19- */
  -ms-flex-order: 2; /* TWEENER - IE 10 */
  -webkit-order: 2; /* NEW - Chrome */
  order: 2; /* NEW, Spec - Opera 12.1, Firefox 20+ */
}
.login-input {
  width: 331px !important;
  display: block !important;
  margin-top: 20px;
}
.login-input .el-input__inner {
  background-color: rgba(246, 246, 246, 1) !important;
  height: 45px !important;
  line-height: 45px !important;
  border: 1px solid #dddddd !important;
}
.login-input .el-input__icon {
  line-height: 45px !important;
}
.login-input ::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #626262 !important;
  font-size: 14px !important;
}

.login-input ::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #626262 !important;
  font-size: 14px !important;
}

.login-input :-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #626262 !important;
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue